import type { DragEventHandler, FC } from "react";
import React, { memo, useCallback } from "react";
import cx from "classnames";

import type { Answer, Column } from "../../../types/main";
import { ExerciseHouseAnswer } from "./answer";

type Props = {
    answers?: Answer[];
    column: Column;
    draggable?: boolean;
    dropzones: [string, number][];
    itemId: string;
    onDrop: (data: { answerId: number; column: number }) => void;
    showAnswers?: boolean;
    success?: boolean;
};

const ExerciseHouseColumnFC: FC<Props> = ({
    answers,
    column,
    draggable,
    dropzones,
    itemId,
    onDrop,
    showAnswers,
    success,
}: Props) => {
    const handleDragOver = useCallback((e) => e.preventDefault(), []);
    const handleDrop: DragEventHandler<HTMLDivElement> = useCallback(
        (e) =>
            onDrop({
                answerId: parseInt(e.dataTransfer.getData("id"), 10),
                column: column.column,
            }),
        [column.column, onDrop]
    );
    return (
        <div
            className={cx("exercise-house__column", {
                "exercise-house__column--success": success,
            })}
            id={itemId}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            <div className="exercise-house__column-title">{column.name}</div>
            {answers?.map((a) => (
                <ExerciseHouseAnswer
                    answer={a}
                    correct={showAnswers ? column.column === a.column : undefined}
                    draggable={draggable}
                    dropzones={dropzones}
                    key={`column_answer_${a.id}`}
                    onDrop={onDrop}
                />
            ))}
            {(answers || []).length === 0 && <div className="exercise-house__column-footer" />}
        </div>
    );
};

export const ExerciseHouseColumn = memo(ExerciseHouseColumnFC);
